/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListBotsOptions, ListBotsResponses } from '../types/ListBots'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List all bots
 * {@link /v1/bots}
 */
export function listBots<ThrowOnError extends boolean = true>(
  options: Options<ListBotsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListBotsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/bots',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListBotsResponses, ThrowOnError>>,
  )
}
